import { render, staticRenderFns } from "./QueryPolicyRisk.vue?vue&type=template&id=76aee2be&scoped=true&"
import script from "./QueryPolicyRisk.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyRisk.vue?vue&type=script&lang=js&"
import style0 from "./QueryPolicyRisk.vue?vue&type=style&index=0&id=76aee2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aee2be",
  null
  
)

export default component.exports